import idCardImg from '../assets/idCard.png'
import idCardBackImg from '../assets/idCardBack.png'
import handholdIdCardImg from '../assets/handholdIdCard.png'
import nucleicAcidDetectionImg from "../assets/nucleicAcidDetectionImg.png"
import licenseImg from '../assets/license.png'
import secondLicenseImg from '../assets/secondLicense.png'
import networkLicenseImg from '../assets/networkLicense.png'
import carLicenseImg from '../assets/carLicense.png'
import carSecondLicenseImg from '../assets/carSecondLicense.png'
import noCrimeCertImg from '../assets/noCrimeCertImg.png'
import uploadElectronicCertificateImg from '../assets/electronic-certificate.png'
// import documentImg from '../assets/license.png'
import carImg from '../assets/car.png'
import carVinImg from '../assets/carVin.png'
import networkCarLicense from '../assets/networkCarLicense.png'
import dialogIdCard from '../assets/dialog-idCard.png'
import dialogIdCardBack from '../assets/dialog-idCardBack.png'
import dialogLicense from '../assets/dialog-license.png'
import dialogSecondLicense from '../assets/dialog-secondLicense.png'
import dialogCarLicense from '../assets/dialog-carLicense.png'
import dialogCarSecondLicense from '../assets/dialog-carSecondLicense.png'
import networkCarTransportLicense from "../assets/networkCarTransportLicense.png"

export const colors = [
  {
    color: '#000',
    name: '黑色',
    id: 6
  },
  {
    color: '#adadad',
    name: '灰色',
    id: 2
  },
  {
    color: '#cccccc',
    name: '银色',
    id: 8
  },
  {
    color: '#fff',
    name: '白色',
    id: 3
  },
  {
    color: '#f00',
    name: '红色',
    id: 4
  },
  {
    color: '#00f',
    name: '蓝色',
    id: 1
  },
  {
    color: '#ccba80',
    name: '金色',
    id: 9
  },
  {
    color: '#8f8a78',
    name: '棕色',
    id: 10
  },
  {
    color: '#b66ea0',
    name: '紫色',
    id: 11
  },
  {
    color: '#0f0',
    name: '绿色',
    id: 7
  },
  {
    color: '#fda0cc',
    name: '粉色',
    id: 12
  },
  {
    color: '#feefa3',
    name: '黄色',
    id: 5
  }
]
export const licencePlates = [
  { name: '京', value: '京' },
  { name: '沪', value: '沪' },
  { name: '津', value: '津' },
  { name: '渝', value: '渝' },
  { name: '冀', value: '冀' },
  { name: '晋', value: '晋' },
  { name: '蒙', value: '蒙' },
  { name: '辽', value: '辽' },
  { name: '吉', value: '吉' },
  { name: '黑', value: '黑' },
  { name: '苏', value: '苏' },
  { name: '浙', value: '浙' },
  { name: '皖', value: '皖' },
  { name: '闽', value: '闽' },
  { name: '赣', value: '赣' },
  { name: '鲁', value: '鲁' },
  { name: '豫', value: '豫' },
  { name: '鄂', value: '鄂' },
  { name: '湘', value: '湘' },
  { name: '粤', value: '粤' },
  { name: '桂', value: '桂' },
  { name: '琼', value: '琼' },
  { name: '川', value: '川' },
  { name: '贵', value: '贵' },
  { name: '云', value: '云' },
  { name: '藏', value: '藏' },
  { name: '陕', value: '陕' },
  { name: '甘', value: '甘' },
  { name: '青', value: '青' },
  { name: '宁', value: '宁' },
  { name: '新', value: '新' }
]
export const ApplyFlowStepForNoCar = [
  {
    num: 1,
    text: '填写个人信息',
    path: '/person-info'
  },
  {
    num: 2,
    text: '上传证件照片',
    path: '/photo-info'
  },
  {
    num: 3,
    text: '报名完成',
    path: '/enroll-result'
  }
]
export const ApplyFlowStepForHasCar = [
  {
    num: 1,
    text: '填写个人信息',
    path: '/person-info'
  },
  {
    num: 2,
    text: '填写车辆信息',
    path: '/car-info'
  },
  {
    num: 3,
    text: '上传证件照片',
    path: '/photo-info'
  },
  {
    num: 4,
    text: '报名完成',
    path: '/enroll-result'
  }
]
// 文件上传类型文档 http://wiki.10101111.com/pages/viewpage.action?pageId=31097517#id-%E6%9E%9A%E4%B8%BE%E4%BF%A1%E6%81%AF%E8%A1%A8-35.%E6%96%87%E4%BB%B6%E4%B8%8A%E4%BC%A0%E7%B1%BB%E5%9E%8B
// 文件上传接口 http://wiki.10101111.com/pages/viewpage.action?pageId=33260373
export const PhotoBaseData = {
  idCard: {
    title: '身份证人像面',
    dsc: '请按示例图上传身份证人像面照片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: true,
    type: 1,
    defaultImg: idCardImg,
    dialogImg: dialogIdCard,
    modifyKey: 'idCardImgUrl',
    supportOcr: true
  },
  idCardBack: {
    title: '身份证国徽面',
    dsc: '请按示例图上传身份证国徽面照片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: true,
    type: 18,
    defaultImg: idCardBackImg,
    dialogImg: dialogIdCardBack,
    modifyKey: 'idCardBackImgUrl',
    supportOcr: true
  },
  handholdIdCard: {
    title: '手持本人身份证',
    dsc: '请确保人脸清晰，且全脸在照片画面中；手持身份证正面，确保证件中文字清晰',
    required: true,
    type: 41,
    defaultImg: handholdIdCardImg,
    modifyKey: 'idCardImgHoldUrl'
  },
  license: {
    title: '驾驶证正本',
    dsc: '请按示例图上传驾驶证正面照片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: true,
    type: 2,
    defaultImg: licenseImg,
    dialogImg: dialogLicense,
    modifyKey: 'licenseImgUrl',
    supportOcr: true
  },
  secondLicense: {
    title: '驾驶证副本',
    dsc: '请按示例图上传驾驶证副面照片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: true,
    type: 3,
    defaultImg: secondLicenseImg,
    dialogImg: dialogSecondLicense,
    modifyKey: 'licenseCopyImgUrl'
  },
  networkLicense: {
    title: '网约车驾驶员证',
    dsc: '请上传网约车驾驶员证原件照片，确保上传有效信息页，图片大小适中，文字清晰、无遮挡、无反光（双开页证件需同时体现两页信息）',
    required: false,
    type: 26,
    defaultImg: networkLicenseImg,
    modifyKey: 'onLineDrivingLicenseUrl'
  },
  acidCheckLicense: {
    title: '核酸检测证明',
    dsc: '请上传正规检验机构提供的7天内真实有效的核酸检测证明原件照片。照片大小适中，文字、印章清晰，无遮挡，无反光。 注：若提供虚假信息需自行承担相应责任。',
    required: false,
    type: 26,
    defaultImg: nucleicAcidDetectionImg,
    modifyKey: 'nucleicAcidDetectionImg'
  },
  carLicense: {
    title: '行驶证正本',
    dsc: '请按示例图上传行驶证正面照片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: true,
    type: 10,
    defaultImg: carLicenseImg,
    dialogImg: dialogCarLicense,
    modifyKey: 'drivingLicenseImgUrl',
    supportOcr: true
  },
  carSecondLicense: {
    title: '行驶证副本',
    dsc: '请按示例图上传行驶证正面照片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: true,
    type: 20,
    defaultImg: carSecondLicenseImg,
    dialogImg: dialogCarSecondLicense,
    modifyKey: 'drivingLicenseImgCopyUrl'
  },
  noCrimeCert: {
    title: '无犯罪记录证明',
    dsc: '请按要求上传无犯罪记录证明文件图片，确保图片文字清晰、无遮挡、无反光',
    required: true,
    type: 20,
    defaultImg: noCrimeCertImg,
    modifyKey: 'noCrimeCertImgUrl'
  },
  car: {
    title: '全车照片',
    dsc: '请按示例图上传全车照片，建议从车辆前方45度角拍摄，确保车牌、车标清晰、无遮挡，车辆整体外观在照片画面中',
    required: true,
    type: 12,
    defaultImg: carImg,
    modifyKey: 'vehicleUrl'
  },
  carVin: {
    title: '车架号照片',
    dsc: '请上传前挡风玻璃左下角车架号照片（示例图位置），文字清晰、无遮挡、无反光',
    required: true,
    type: 13,
    defaultImg: carVinImg,
    modifyKey: 'vehicleFrameUrl'
  },
  /** 车证 - 网约车 改成 网络预约出租汽车运输证  */
  networkCarLicense: {
    title: '网约车运输证',
    dsc: '请上传网约车运输证原件照片，确保上传有效信息页，图片大小适中，文字清晰、无遮挡、无反光；（可折叠证件需将正本和副本前两页信息同时体现；翻页证件需将正本和副本第二页信息同时体现）',
    required: false,
    type: 25,
    defaultImg: networkCarLicense,
    modifyKey: 'onLineVehicleTransportationLicenseUrl'
  },
  /** 车证 - 网约车 改成 网络预约出租汽车运输证  */
  networkCarTransportLiscense:{
    title: '网络预约出租汽车运输证',
    dsc: '请上传网络预约出租汽车运输证原件照片，确保上传有效信息页，图片大小适中，文字清晰，无遮挡、无反光；（双开页证件需同时提现两页信息）',
    required: false,
    type: 25,
    defaultImg: networkCarTransportLicense,
    modifyKey: 'onLineVehicleTransportationLicenseUrl'
  },
  electronicCertificate: {
    title: '电子行驶证',
    dsc: '请按示例图上传电子行驶证图片，确保图片大小适中，文字清晰、无遮挡、无反光',
    required: false,
    type: 48,
    defaultImg: uploadElectronicCertificateImg,
    dialogImg: uploadElectronicCertificateImg,
    modifyKey: 'electronicVehicleLicenseUrl'
  },
}
// 照片字段与类型映射表
export const PhotoTypeMap = {
  1: 'idCard',
  18: 'idCardBack',
  41: 'handholdIdCard',
  2: 'license',
  3: 'secondLicense',
  26: 'networkLicense',
  10: 'carLicense',
  20: 'carSecondLicense',
  12: 'car',
  13: 'carVin',
  25: 'networkCarLicense',
  48: 'electronicVehicleLicenseUrl',
}
export const AboutUPlus = {
  content: '关于优驾开放平台',
  dsc: '优驾开放平台由神州专车倾力打造，是中国首个专车共享的免费开放平台，免费共享千万级神州专车需求，共享中国第一专车品牌资源。',
  list: ['零剥削：平台永不抽成', '高价值：平均金额80元', '高素质：乘客素质高，工作体面受尊重', '0犯罪记录：严审司机无犯罪记录', '虚拟安全号码，杜绝骚扰', '人脸识别，行程分享，保障安全']
}
export const loginStatus = {
  fillInfo: 1, // 填充信息状态，可进入person-info, car-info, team-info, team-activating
  reviewInfo: 2, // 审核信息状态，可进入报名流程详情页 enroll-result
  modifyInfo: 3, // 修改已提交信息状态，可进入修改资料，预约面试页面
  teamReviewInfo: 4, // 车队审核信息状态，可进入车队报名流程详情页 team-result 与车队报名激活页 team-activating（未激活状态）
  teamActivated: 5 // 车队已激活状态，可进入车队报名流程页 team-result 与车队报名激活页 team-activating（已激活状态）
}
export const regProcessForNocar = [
  '注册报名',
  '成为预备司机',
  '待办事项上传',
  '审核信息通过',
  '成为正式司机',
  '选车',
  '提车',
  '开始接单'
]
export const regProcessForHascar = [
  '注册报名',
  '成为预备司机',
  '待办事项上传',
  '审核信息通过',
  '成为正式司机',
  '绑定车辆',
  '开始接单'
]
export const companyRegProcessForNocar = [
  '注册报名',
  '成为预备司机',
  '待办事项上传',
  '审核信息通过',
  '成为正式司机',
  '选车',
  '企业分配车辆',
  '上线接单'
]
export const companyRegProcessForHascar = [
  '注册报名',
  '成为预备司机',
  '待办事项上传',
  '审核信息通过',
  '成为正式司机',
  '绑定车辆',
  '上线接单'
]
// 培训学习同步时间间隔 单位秒: s
export const studySyncTime = 60
// 培训考试同步时间间隔 单位秒: s
export const examSyncTime = 60
// 报名状态代入驻文案
export const alreadyRegText = '对不起，您已是神州优车正式司机（手机或身份证号已存在且账号有效），不支持重复开通。请您直接登录原账号上线，如有疑问，请联系神州工作人员。'
// ocr身份证正面对象初始状态
export const resetIdCard = {
  name: '',
  gender: 1,
  birthday: '',
  address: '',
  idCardNo: ''
}
// ocr身份证反面对象初始状态
export const resetIdCardBack = {
  issuingAuthority: '',
  validFrom: '',
  validTo: ''
}
// ocr驾驶证对象初始状态
export const resetDriverLicense = {
  driverLicenseNo: '',
  driverLicenseName: '',
  driverLicenseAddress: '',
  driverLicenseBirthday: '',
  driverLicenseIssueDate: '',
  driverLicenseClass: '',
  driverLicenseValidFrom: '',
  driverLicenseValidTo: ''
}
// ocr行驶证对象初始状态
export const resetVehicleLicense = {
  region: '',
  licenceNum: '',
  vehicleLicenseVehicleType: '',
  vehicleLicenseOwner: '',
  vehicleLicenseAddress: '',
  vehicleLicenseUseCharacter: '',
  vehicleLicenseVin: '',
  vehicleLicenseEngineNo: '',
  vehicleLicenseRegisterDate: '',
  vehicleLicenseIssueDate: ''
}

export const checkFailText = {
  offLine: '已注册为神州专车司机且已停运，请停运满3个月后重新申请',
  settledByLogin: '您已成为神州大家庭的一员，请勿重复申请，登录司机端上线接单吧',
  settledBySubmit: '已注册为神州专车司机，可直接使用注册手机号登录神州专车司机App开始工作'
}
